module.exports = __webpack_public_path__ + "img/bg.3d3c9171.png";